import { createApi } from '@reduxjs/toolkit/query/react';

import { lubavAppBaseQuery } from '../baseQuery';

type ScoreDimensionsRequest = Readonly<{
  track_assessment_result_id: number;
  category_slug?: string;
}>;

type DimensionScore = Readonly<{
  dimension_id: number;
  score_level: string;
  justification: string;
}>;

type ScoreDimensionsResponse = Readonly<{
  scores: DimensionScore[];
}>;

export const trackAssessmentApiLubav = createApi({
  reducerPath: 'trackAssessmentApiLubav',
  baseQuery: lubavAppBaseQuery,
  endpoints: (build) => ({
    scoreDimensions: build.mutation<ScoreDimensionsResponse, ScoreDimensionsRequest>({
      query: (body) => ({
        url: 'api/generate/track-assessment/dimension-scores',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useScoreDimensionsMutation } = trackAssessmentApiLubav;
